import { pickT } from "@repo/shared";
import type { LocaleCode } from "@repo/shared/types";
import { T } from "./sso-sign-in-error.i18n";

/**
 * The API refuses a stored provider it will not call (QL-621) with a code the
 * user can act on (contact the administrator, or retry). Null for any other error.
 */
export function ssoRefusalMessage(code: string | undefined, language: LocaleCode): string | null {
  const t = pickT(T, language);
  if (code === "sso_provider_not_allowed") return t.notAllowed;
  if (code === "sso_provider_unavailable") return t.unavailable;
  return null;
}
